<div onsip-grid-placement-shelf>
  <div class="first-column">
    <section>
      <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.PARKING_LOT_MUSIC" | translate }}</div>
      <div>{{ parkLot.musicSourceName }}</div>
    </section>

    <section>
      <div class="mat-body-1 m-b-12">
        {{ "ONSIP_I18N.PARKING_LOT_MANUAL_RETURN_BTN" | translate }}
      </div>
      <div>
        {{ parkLot.manualReturnDtmf ? parkLot.manualReturnDtmf : ("ONSIP_I18N.NONE" | translate) }}
      </div>
    </section>
  </div>

  <div class="second-column">
    <section>
      <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.PARKING_LOT_AUTO_RETURN" | translate }}</div>
      <div>{{ parkLot.autoReturnTimeout }} seconds</div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.FAILOVER_ADDRESS" | translate }}</div>
      <div>
        {{
          parkLot.failover.name
            ? "(" +
              (parkLot.failover.addressType | singularAddressType) +
              ") " +
              parkLot.failover.name
            : ("ONSIP_I18N.NONE" | translate)
        }}
      </div>
    </section>
  </div>
</div>

<div class="page-view-controls">
  <button mat-flat-button color="primary" (click)="editPanel.emit()">
    {{ "ONSIP_I18N.EDIT_INFO" | translate }}
  </button>
</div>
